import { IconButton, Tooltip } from "@chakra-ui/react";
import { Eye, EyeClosed } from "@phosphor-icons/react";
import { useDispatch, useSelector } from "react-redux";
import useAirUserRoles from "utils/AuthUtils";
import { toggleAdminFeatures } from "context/Store/slices/adminViewSlice";

/**
 * Lets an ESG Admin hide/show ESG_ADMIN-only UI across the app (see EsgAdminOnly.jsx).
 * Always visible to ESG Admins regardless of the toggle state it controls - otherwise
 * there would be no way to turn admin features back on. Invisible to everyone else.
 */
export default function EsgAdminViewToggle() {
  const { isESGAdmin } = useAirUserRoles();
  const showAdminFeatures = useSelector((state) => state.adminView?.showAdminFeatures ?? true);
  const dispatch = useDispatch();

  if (!isESGAdmin) {
    return null;
  }

  const label = showAdminFeatures ? "Hide ESG Admin features" : "Show ESG Admin features";

  return (
    <Tooltip label={label} placement="bottom" openDelay={300}>
      <IconButton
        aria-label={label}
        variant="ghost"
        size="sm"
        fontSize="xl"
        color="gray.600"
        _hover={{ bg: "gray.100" }}
        onClick={() => dispatch(toggleAdminFeatures())}
        icon={showAdminFeatures ? <Eye size={20} weight="bold" /> : <EyeClosed size={20} weight="bold" />}
      />
    </Tooltip>
  );
}
